var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.75C8.787 3.75 3.75 8.787 3.75 15S8.787 26.25 15 26.25 26.25 21.213 26.25 15 21.213 3.75 15 3.75zM1.25 15C1.25 7.406 7.406 1.25 15 1.25S28.75 7.406 28.75 15 22.594 28.75 15 28.75 1.25 22.594 1.25 15z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.75c.69 0 1.25.56 1.25 1.25v10a1.25 1.25 0 11-2.5 0V10c0-.69.56-1.25 1.25-1.25z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 15c0-.69.56-1.25 1.25-1.25h10a1.25 1.25 0 110 2.5H10c-.69 0-1.25-.56-1.25-1.25z",
    fill: "#ED1B2E"
  })));
}

export default SvgPlusCircle;